export default __webpack_public_path__ + "static/media/03_01.57ba5aaa.png";